import { render, staticRenderFns } from "./eventListPage.vue?vue&type=template&id=74f09a85&"
import script from "./eventListPage.vue?vue&type=script&lang=ts&"
export * from "./eventListPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports